import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";
import { MS_5_MINUTES } from "../../defines";
import { useAuthenticated } from "../authenticated/useAuthenticated";
import { logError } from "../../../../helpers/src/errors/logError";

export const useOrganizationSettings = ({
  id,
  disabled = false,
  refetchInterval = MS_5_MINUTES, // default to 5 minutes
  forAccountSettings = false
}: {
  id: string | null | undefined;
  disabled?: boolean;
  refetchInterval?: number;
  forAccountSettings?: boolean;
}) => {
  const { apiClient } = useTacticHooks();
  const {
    userContext: { deviceTz }
  } = useAuthenticated();

  return useQuery({
    queryKey: ["organization-settings", id, { forAccountSettings }],
    queryFn: async () => {
      if (!id) {
        return null;
      }
      try {
        const data =
          await apiClient.orgOrOfficeSettings.getOrganizationSettings(
            deviceTz,
            forAccountSettings
          );
        if (data.ok && data.result) {
          return data.result;
        }
        throw data;
      } catch (error) {
        logError("Error fetching organization settings", error);
        throw error;
      }
    },
    enabled: !!id && !disabled,
    refetchInterval
  });
};
